
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nido/risorse",
      function () {
        return require("private-next-pages/nido/risorse.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nido/risorse"])
      });
    }
  